module.exports = __webpack_public_path__ + "img/folder_eye.1d7171f7.svg";